import { render, staticRenderFns } from "./AccessMag.vue?vue&type=template&id=094ba380&scoped=true&"
import script from "./AccessMag.vue?vue&type=script&lang=js&"
export * from "./AccessMag.vue?vue&type=script&lang=js&"
import style0 from "./AccessMag.vue?vue&type=style&index=0&id=094ba380&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094ba380",
  null
  
)

export default component.exports